import { Component } from '@angular/core';

import { NumberFieldComponent } from './number-field.component';

@Component({
  selector: 'app-index-field-component',
  templateUrl: './text-field.component.html',
  styleUrls: ['./text-field.component.scss']
})
export class IndexFieldComponent extends NumberFieldComponent {
  copyable: boolean = false;
  integer: boolean = true;
  positive: boolean = true;
}


// WEBPACK FOOTER //
// ./src/app/forms/index-field.component.ts